<template>
	<b-tab :title="$t(data.name)">
    <b-tabs nav-wrapper-class="transaction-status mb-2 pb-0" v-model="tabIndex">
          <TransactionStatus v-for="item in status" :data="item" :type="data.id" :list="status" :key="item.id"></TransactionStatus>
    </b-tabs>
	</b-tab>
</template>
<script>
  import Vue from 'vue'
  import TransactionStatus from '@/components/TransactionHistory/TransactionStatus';

  const status_list = [
          {
            "id":1,
            "enum":'[0,1,2,3,5]',
            "name":"All"
          },
          {
            "id":3,
            "enum":'[0,5]',
            "name":"Pending"
          },
          {
            "id":4,
            "enum":2,
            "name":"Approved"
          },
          {
            "id":5,
            "enum":3,
            "name":"Rejected"
          }
        ];

  export default {
    name: 'deposit-history',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        tabIndex:-1,
        status : status_list,
        search : ''
      }
    },
    props: ['data'],
    components: {
      TransactionStatus
    },
    methods:{
     
    }
  };
</script>
